export default __webpack_public_path__ + "static/media/Icon-Recovery.63d6691e.svg";